// extracted by mini-css-extract-plugin
export default {"root":"DoRandomModal_root__dnXvK","select":"DoRandomModal_select__wRELr","gap":"DoRandomModal_gap__bOn4p","alert":"DoRandomModal_alert__8glbw"};